import React from 'react'
import LanguageSwitcher from '../lanswitcher'
import { useTranslation } from "react-i18next";

import { Container, Nav, Navbar } from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';
import { NavLink } from 'react-router-dom';

import "../App.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
function NavBar() {

  const { t } = useTranslation();
  return (

    <>
    <Navbar  expand="lg">
        <Container className='nav'>
            <NavLink className="logo" to="/">
            
            <h1 className="logo">
              <img src="logo.png" alt="" width={"80px"} />
            </h1>
            
            </NavLink>
           
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="navlinks">
                    <NavLink to="/">{t("home")}</NavLink>
                    <NavLink to="/About">{t("about")}</NavLink>
                    <NavLink to="/Contact">{t("contact")}</NavLink>
                    <HashLink to="/#gallery">{t("services")}</HashLink>
                   
                </Nav>
               
            </Navbar.Collapse>
            <LanguageSwitcher/>
        </Container>
    </Navbar >
    {/* end navbar  */}
</>
  )
}

export default NavBar
